import { createContext } from "react";
import { IKeycloakProfile } from "itsf-ui-common";

export const UserContext = createContext<IKeycloakProfile>({
    username: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    keycloakUuid: "",
    keycloakRoles: {},
    keycloakChannels: [],
});
